<template>
  <div class="d-inline-block">
    <h1 class="mb-6">Oeps! Optie niet actief</h1>
    <v-row>
      <v-col cols="2" class="d-flex justify-center align-center">
        <v-icon x-large>mdi-lock</v-icon>
      </v-col>
      <v-col cols="10" class="d-flex justify-center align-center">
        <div>
          <p class="ma-0" v-if="hasAccessToSettingsRoute">
            <span>Zet deze optie aan via
            <router-link :to="{name: settingsRoute}">instellingen</router-link>.
          </span>
          </p>
          <p class="ma-0" v-else>
            <span>Vraag je administrator om deze optie open te zetten.</span>
            <span class="d-inline-block">Of ga terug naar de
            <router-link :to="{name: calendarRoute}">kalender</router-link>.
          </span>
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import RouteNames from "@/router/RouteNames";
import {hasAccessToRoute} from "@/shared/utils/authenticationUtils";

export default {
  name: "OptionDisabled.vue",
  data() {
    return {
      calendarRoute: RouteNames.CALENDAR,
      settingsRoute: RouteNames.SETTINGS_PARAMETERS,
      hasAccessToSettingsRoute: hasAccessToRoute(RouteNames.SETTINGS_PARAMETERS)
    }
  },
}
</script>